module.exports = global["RdcTracking"] = require("-!/data/app/rdc-next/node_modules/source-map-loader/index.js!./index.js");


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/index.js
// module id = 300
// module chunks = 48 49 50